"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMakeSelectStyles = exports.useSelectStyles = void 0;
var tslib_1 = require("tslib");
var styles_1 = require("@material-ui/core/styles");
var style_1 = require("../../../style");
exports.useSelectStyles = function (errorProp) { return ({
    control: function (provided) {
        return tslib_1.__assign(tslib_1.__assign({}, provided), { width: '100%', maxWidth: '300px', height: '40px', borderRadius: '4px', border: errorProp ? "solid 1px " + style_1.mediumRed : "solid 1px " + style_1.mediumLightBlue, backgroundColor: 'white', fontFamily: '"Roboto", "Helvetica Neue", Helvetica, Arial, sans-serif', boxShadow: 'none', ':focus': tslib_1.__assign(tslib_1.__assign({}, provided[':focus']), { border: errorProp ? "solid 1px " + style_1.mediumRed : "solid 1px " + style_1.mediumLightBlue }), '&:hover': {
                border: errorProp ? "solid 1px " + style_1.mediumRed : "solid 1px " + style_1.mediumLightBlue,
            } });
    },
    menu: function (provided, state) { return (tslib_1.__assign(tslib_1.__assign({}, provided), { width: '100%', borderBottom: "1px solid " + style_1.mediumLightBlue, color: state.selectProps.menuColor, marginTop: '1px', fontFamily: '"Roboto", "Helvetica Neue", Helvetica, Arial, sans-serif', boxShadow: '0 8px 16px 0 rgba(0, 0, 0, 0.08)' })); },
    placeholder: function (provided) { return (tslib_1.__assign(tslib_1.__assign({}, provided), { opacity: 1, color: style_1.mediumLightBlue, fontFamily: '"Roboto", "Helvetica Neue", Helvetica, Arial, sans-serif', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: 'calc(100% - 8px)' })); },
    indicatorSeparator: function (provided) { return (tslib_1.__assign(tslib_1.__assign({}, provided), { backgroundColor: 'none' })); },
    dropdownIndicator: function (provided) { return (tslib_1.__assign(tslib_1.__assign({}, provided), { opacity: 1, color: style_1.darkBlue, '&:hover': {
            color: style_1.darkBlue,
        } })); },
    noOptionsMessage: function (provided) { return (tslib_1.__assign(tslib_1.__assign({}, provided), { opacity: 1, color: style_1.mediumLightBlue, fontFamily: '"Roboto", "Helvetica Neue", Helvetica, Arial, sans-serif' })); },
    singleValue: function (provided, state) {
        var opacity = state.isDisabled ? 0.5 : 1;
        var transition = 'opacity 300ms';
        var color = state.data.value === 'placeholder' ? style_1.mediumLightBlue : style_1.darkBlue;
        return tslib_1.__assign(tslib_1.__assign({}, provided), { opacity: opacity,
            color: color,
            transition: transition, fontSize: '16px', fontFamily: '"Roboto", "Helvetica Neue", Helvetica, Arial, sans-serif', fontWeight: 'normal', fontStretch: 'normal', fontStyle: 'normal', lineHeight: '1.06', letterSpacing: 'normal' });
    },
    option: function (styles, state) {
        var isDisabled = state.isDisabled, isFocused = state.isFocused, isSelected = state.isSelected;
        return tslib_1.__assign(tslib_1.__assign({}, styles), { color: style_1.darkBlue, backgroundColor: isDisabled ? null : isSelected ? style_1.lightBlue : isFocused ? style_1.lightLightBlue : null, ':active': tslib_1.__assign(tslib_1.__assign({}, styles[':active']), { color: style_1.darkBlue, backgroundColor: !isDisabled && (isSelected ? style_1.lightLightBlue : style_1.lightBlue) }) });
    },
}); };
exports.useMakeSelectStyles = styles_1.makeStyles(function () { return ({
    error: {
        position: 'absolute',
        bottom: '5px',
        fontSize: '12px',
        fontWeight: 'normal',
        color: style_1.mediumRed,
        fontFamily: '"Roboto", "Helvetica Neue", Helvetica, Arial, sans-serif',
    },
    selectContainer: {
        position: 'relative',
        paddingBottom: '24px',
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
    },
    label: {
        width: '100%',
        lineHeight: '17px',
        fontSize: '14px',
        marginBottom: '4px',
        color: style_1.darkBlue,
        fontWeight: 'normal',
        fontFamily: '"Roboto", "Helvetica Neue", Helvetica, Arial, sans-serif',
    },
}); });
